/* Cart progress bars and "Complete the set" buttons. Loaded by the cart drawer and cart page. */
(() => {
  if (window.nbCartLoaded) return;
  window.nbCartLoaded = true;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const rate = () => parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;

  class NbCartProgress extends HTMLElement {
    connectedCallback() {
      const total = parseInt(this.dataset.total, 10) || 0;
      const currency = this.dataset.currency || 'GBP';
      const format = (cents) => {
        const value = cents / 100;
        const digits = Number.isInteger(value) ? 0 : 2;
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency', currency, minimumFractionDigits: digits, maximumFractionDigits: 2
          }).format(value);
        } catch (e) {
          return value.toFixed(digits);
        }
      };

      this.querySelectorAll('.nb-progress__row').forEach((row) => {
        const goal = Math.round((parseInt(row.dataset.goal, 10) || 0) * rate());
        if (!goal) return;
        const left = Math.max(0, goal - total);
        const text = row.querySelector('.nb-progress__text');
        row.classList.toggle('is-met', left === 0);
        row.style.setProperty('--nb-progress', Math.min(1, total / goal));
        if (left === 0) {
          text.textContent = row.dataset.textMet;
        } else {
          const [before, after] = row.dataset.textUnder.split('[amount]');
          const amount = document.createElement('strong');
          amount.textContent = format(left);
          text.replaceChildren(before, amount, after || '');
        }
      });
      this.hidden = false;
    }
  }
  if (!customElements.get('nb-cart-progress')) customElements.define('nb-cart-progress', NbCartProgress);

  const post = (url, body) => fetch(`${root()}${url}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  }).then((response) => {
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return response.json();
  });

  document.addEventListener('click', async (evt) => {
    const btn = evt.target.closest('[data-nb-offer]');
    if (!btn || btn.disabled) return;
    evt.preventDefault();
    btn.disabled = true;
    try {
      // Add first, so nothing is removed if the add fails.
      await post('cart/add.js', { items: [{ id: parseInt(btn.dataset.variant, 10), quantity: 1 }] });
      if (btn.dataset.updates) {
        const updates = {};
        btn.dataset.updates.split('|').filter(Boolean).forEach((pair) => {
          const i = pair.lastIndexOf('=');
          updates[pair.slice(0, i)] = parseInt(pair.slice(i + 1), 10);
        });
        await post('cart/update.js', { updates });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.message);
      btn.disabled = false;
    }
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
  });
})();
